import React from 'react';
import Tilt from 'react-parallax-tilt';
import brain from './Brain.png';
import './Logo.css';

const Logo = () => {
  return(
    <div className='ma4 mt0 Tilt' >
      <Tilt>
        <div className = 'Tilt-inner br2 shadow-2 tc pa3' >
           <img alt='Brain-Logo' src={brain} />
        </div>
      </Tilt>
    </div>
  );
}

export default Logo;
